export default function extractUrn(urn) {
  const [type, id] = urn.split(':').slice(-2);
  return { id, type };
}
